import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import HPOTree from "../../../../components/atoms/HPOTree";
import HPOSelector from "./HPOSelector";
import { Label } from "../../../../components/atoms/Form";
import PhenotypesRadioButtons from "../../../../components/atoms/GermlineModeForm/PhenotypesRadioButtons";

const HPOScreen = (props) => {
  const {
    hpo,
    addDisease,
    addPhenotype,
    updateNumberOfSelections,
    numberOfHPOSelections,
  } = props;
  const hpoLimitReached = numberOfHPOSelections > 100;

  const [hpoObj, setHpoObj] = useState([]);
  const [sourcesStatus, setSourcesStatus] = useState([]); // returns if the source is checked or not
  const [selectedSource, setSelectedSource] = useState([]); // user selected source [all, omim]

  useEffect(() => {
    const newHpoObj = [...hpoObj];
    newHpoObj[0] = hpo;
    setHpoObj(newHpoObj);
  }, [hpo]);

  useEffect(() => {
    const sourceSelected = sourcesStatus.filter(
      (source) => source.checked === true
    );
    const selectedSourceName = sourceSelected.map((source) => source.value);
    setSelectedSource(selectedSourceName);
  }, [sourcesStatus]);

  return (
    <div>
      <div className="row">
        <div className="col-12 col-xs-12">
          <p style={{ fontSize: "1.1rem" }}>
            <strong>
              Please add any phenotypes this variant is linked to.
            </strong>
            <br />
            Adding the phenotype(s) will make your contribution more useful for
            the community.
          </p>
        </div>
      </div>
      <Label
        text="Phenotype names from"
        helperText="Get phenotype names from all sources or from OMIM only"
      />
      <div>
        <PhenotypesRadioButtons
          returnPhenotypesSourcesStatus={(phenotypes) =>
            setSourcesStatus(phenotypes)
          }
        />
      </div>
      <HPOSelector
        hpo={hpo}
        addDisease={addDisease}
        addPhenotype={addPhenotype}
        selectedSource={selectedSource}
      />
      {hpoLimitReached && (
        <div className="tw-flex-grow tw-text-right tw-px-2">
          <span className="tw-text-red-600">
            You can select up to 100 diseases or phenotypes.
          </span>
        </div>
      )}
      <div>
        <div className="col-12 col-xs-12">
          <HPOTree
            updateNumberOfSelections={updateNumberOfSelections}
            checkBoxes={true}
            HPOTree={{ hpo: hpoObj }}
          />
        </div>
      </div>
    </div>
  );
};

HPOScreen.propTypes = {
  hpo: PropTypes.shape({
    diseases: PropTypes.arrayOf(PropTypes.shape({})),
    phenotypes: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  addDisease: PropTypes.func.isRequired,
  addPhenotype: PropTypes.func.isRequired,
  updateNumberOfSelections: PropTypes.func.isRequired,
  numberOfHPOSelections: PropTypes.number,
};

HPOScreen.defaultProps = {
  hpo: { diseases: [], phenotypes: [] },
  numberOfHPOSelections: 0,
};

export default HPOScreen;
